<template>
    <div v-if="question" class="bands">
        <button v-for="(option, i) in question.options" :key="i" type="button" class="band" :class="bandClass(option)"
            @click="select(option)">
            <span class="band-bg">{{ option.value }}</span>
            <span class="band-inner">
                <span class="band-num">{{ option.value }}</span>
                <span class="band-text">
                    <span class="band-label">{{ option.text }}</span>
                </span>
                <span class="band-check">
                    <v-icon size="14" color="white">mdi-check</v-icon>
                </span>
            </span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            selected: null,
            locked: false,
        }
    },
    methods: {
        bandClass(option) {
            const vm = this
            return [
                `wb-${option.value}`,
                {
                    'is-selected': vm.selected === option.value,
                    'is-dim': vm.selected !== null && vm.selected !== option.value,
                },
            ]
        },
        select(option) {
            const vm = this
            if (vm.locked) return
            vm.locked = true
            vm.selected = option.value
            setTimeout(() => {
                vm.$emit('click:next', vm.question, { ...option })
            }, 360)
        },
    },
}
</script>

<style scoped>
.bands {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 14px;
}

.band {
    flex: 1;
    border: none;
    padding: 0;
    cursor: pointer;
    text-align: left;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    transition: flex 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.band.is-dim {
    flex: 0.4;
    opacity: 0.5;
}

.band.is-selected {
    flex: 3;
    animation: band-pop 0.3s ease;
}

@keyframes band-pop {
    0% { transform: scale(1); }
    40% { transform: scale(1.02); }
    100% { transform: scale(1); }
}

.band-inner {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 0 20px;
    width: 100%;
}

.band-num {
    font-size: 34px;
    font-weight: 800;
    flex-shrink: 0;
    line-height: 1;
    transition: font-size 0.3s, color 0.2s;
}

.band.is-selected .band-num {
    color: #fff;
    font-size: 50px;
}

.band.is-dim .band-num {
    font-size: 22px;
}

.band-text {
    flex: 1;
    min-width: 0;
}

.band-label {
    font-size: 15px;
    font-weight: 700;
    transition: color 0.2s, font-size 0.3s;
}

.band.is-selected .band-label {
    color: #fff;
    font-size: 18px;
}

.band.is-dim .band-label {
    font-size: 12px;
}

.band-check {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    opacity: 0;
    transition: opacity 0.2s;
}

.band.is-selected .band-check {
    opacity: 1;
}

.band-bg {
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 90px;
    font-weight: 800;
    opacity: 0.05;
    line-height: 1;
    pointer-events: none;
    color: currentColor;
}

/* Color scale by value */
.wb-5 { background: rgba(0, 153, 102, 0.16); }
.wb-4 { background: rgba(51, 153, 153, 0.11); }
.wb-3 { background: rgba(200, 160, 0, 0.10); }
.wb-2 { background: rgba(200, 136, 0, 0.13); }
.wb-1 { background: rgba(232, 92, 92, 0.18); }

.wb-5 .band-num, .wb-5 .band-label { color: #009966; }
.wb-4 .band-num, .wb-4 .band-label { color: #339999; }
.wb-3 .band-num, .wb-3 .band-label { color: #A07800; }
.wb-2 .band-num, .wb-2 .band-label { color: #C88800; }
.wb-1 .band-num, .wb-1 .band-label { color: #E85C5C; }

.wb-5.is-selected { background: #009966; }
.wb-4.is-selected { background: #339999; }
.wb-3.is-selected { background: #C88800; }
.wb-2.is-selected { background: #C88800; }
.wb-1.is-selected { background: #E85C5C; }
</style>
